/* import __COLOCATED_TEMPLATE__ from './user-inactivity.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();